import styled from 'styled-components'
import { danger, dangerHover, dangerTint } from '@/theme/colors'
import { radii } from '@/theme/tokens'
import { text } from '@/theme/typography'

/**
 * A page or section that could not load: the message, centered, in the danger
 * color, sitting where the content would have been. The counterpart of the
 * EmptyState's `EmptyNote`.
 */
export const ErrorNote = styled.div`
	${text.bodySm}
	color: ${danger};
	text-align: center;
	margin: 0;
	padding: 32px 16px;
`

/** A failure that needs the eye inside a form or a list: the tinted band with a hairline. */
export const ErrorBanner = styled.div`
	${text.bodyXs}
	color: ${dangerHover};
	background: ${dangerTint};
	border: 1px solid ${danger}40;
	border-radius: ${radii.inner};
	padding: 12px 16px;
	text-align: center;
`
